import * as React from "react"

interface IconProps {
  color?: string
}

export const AddTerminalIcon: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 7.21203C2 6.8664 2.16947 6.59551 2.40629 6.4668C3.55654 5.84167 5.42751 5 7 5C8.57249 5 10.4435 5.84167 11.5937 6.4668C11.8305 6.59551 12 6.8664 12 7.21203V18C12 18.5523 11.5523 19 11 19H3C2.44772 19 2 18.5523 2 18V7.21203Z"
      stroke="#616161"
      strokeWidth="2"
    />
    <path d="M20 8H18V11H15V13H18V16H20V13H23V11H20V8Z" fill={color} />
  </svg>
)
